import { useCallback } from 'react';

import { ButtonText } from 'src/components/ButtonText';
import { ChevronIcon } from 'src/components/ChevronIcon';
import { ROTATE_DIRECTION } from 'src/data/ui';
import { useAvailableLanguages } from 'src/services';

import { useSelectLanguagePopup } from '../SelectLanguagePopup';

export const SelectLanguageButton = ({
  className,
  language,
  onSubmit,
  dropdownDisabled,
  buttonDisabled,
}) => {
  const openSelectLanguagePopup = useSelectLanguagePopup();
  const availableLanguages = useAvailableLanguages();
  const currentLanguage = availableLanguages.find(
    (availableLanguage) => availableLanguage.value === language
  );

  const handleOpenLanguagePopup = useCallback(() => {
    openSelectLanguagePopup({
      language,
      onSubmit,
      disabled: dropdownDisabled,
    });
  }, [openSelectLanguagePopup, language, onSubmit, dropdownDisabled]);

  return (
    <ButtonText
      className={className}
      onClick={handleOpenLanguagePopup}
      endIcon={<ChevronIcon direction={ROTATE_DIRECTION.down} />}
      disabled={buttonDisabled}
    >
      {currentLanguage?.label}
    </ButtonText>
  );
};
